export default __webpack_public_path__ + "static/media/gallery_08.2e929d01.jpg";